<template>
    <v-select
        hide-details
        variant="outlined"
        density="compact"
        :disabled="$attrs.disabled"
        :label="$t('flights.select_class')"
        :items="offerClasses"
        :model-value="value ? value.classType : offerClasses[0]"
        eager
        @update:model-value="saveClass($event)"
    />
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class FlightClassSelector extends Vue {
        @Prop() offer
        @Prop({default: null}) value

        order = ['ECONOMY', 'PREMIUM_ECONOMY', 'BUSINESS', 'FIRST_CLASS']

        mounted() {
            this.saveClass(this.value ? this.value.classType : this.offerClasses[0])
        }

        saveClass(cls) {
            if (this.offer.itinerary[0].segments[0].categoryClasses) {
                const categoryClass = this.offer.itinerary[0].segments[0].categoryClasses.find(
                    ({classType}) => classType === cls
                )
                this.$emit('select-class', categoryClass)
            }
        }

        get offerClasses() {
            if (!this.offer.itinerary[0].segments[0].categoryClasses) {
                return []
            }
            const classes = this.offer.itinerary[0].segments[0].categoryClasses.map(({classType}) => classType)
            classes.sort((a, b) => {
                return this.order.indexOf(a) + 1 - (this.order.indexOf(b) + 1)
            })
            return classes.map(value => ({value, title: this.$t(`filters_class.${value}`)}))
        }
    }

    export default FlightClassSelector
</script>

<style lang="scss" scoped>
    :deep(.v-select__selections) {
        font-size: 14px;
    }
</style>
